import { Box, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useUISize } from 'app/utils/web-helpers';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

interface RequestEmptyStateProps {
  onPressViewAll?: () => void;
}

export function RequestEmptyState({ onPressViewAll }: RequestEmptyStateProps) {
  const { t } = useTranslation('landing-page');
  const { isSmallUI } = useUISize();

  return (
    <Box
      backgroundColor="surface.tertiary-neutral"
      borderRadius="radius.md"
      marginHorizontal={isSmallUI ? 'spacing.general.x5' : 'spacing.general.0'}
      marginTop="spacing.general.x2"
      padding="spacing.general.x4"
    >
      <Row alignItems="flex-start" gap="spacing.general.x3">
        <Text fontSize={24}>👋</Text>
        <Box flex={1}>
          <Text fontWeight="600" variant="bodyBase">
            {t('requests.emptyState.title')}
          </Text>
          <Text color="text.secondary" marginTop="spacing.general.x0,5" variant="bodyBase">
            {t('requests.emptyState.subtitle')}
          </Text>
          {onPressViewAll ? (
            <Pressable onPress={onPressViewAll}>
              <Text color="text.interactive" fontWeight="600" marginTop="spacing.general.x2" variant="bodyBase">
                {t('requests.emptyState.cta')}
              </Text>
            </Pressable>
          ) : null}
        </Box>
      </Row>
    </Box>
  );
}
